module.exports = __webpack_public_path__ + "static/img/icn_mall_3d.4c6ba87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/icn_mall_3d.png
// module id = TyYp
// module chunks = 1